import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd3f3e58")

_pushScopeId("data-v-fd3f3e58")
const _hoisted_1 = { class: "loader" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"cube-anim\" data-v-fd3f3e58><div class=\"cube1 cube\" data-v-fd3f3e58></div><div class=\"cube2 cube\" data-v-fd3f3e58></div><div class=\"cube4 cube\" data-v-fd3f3e58></div><div class=\"cube3 cube\" data-v-fd3f3e58></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2
  ]))
})